module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (113).7aa77420.jpg";